import HttpClient from "@/services/HttpClient";
import { EServices } from "@/types";
import { inject, injectable } from "tsyringe";
import { INotification } from "../types";

@injectable()
export default class NotificationsClient {
  constructor(@inject(EServices.http) private http: HttpClient) {}

  async getNotifcations(): Promise<INotification[]> {
    const response = await this.http.get("/v1/app/notifications");
    return response.data;
  }

  async markNotificationAsRead(notificationId: number): Promise<INotification> {
    const response = await this.http.get(
      `/v1/app/notifications/${notificationId}/read`
    );
    return response.data;
  }
}
